import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.08105 7.99967H13.4144M13.4144 7.99967L8.74772 3.33301M13.4144 7.99967L8.74772 12.6663",
		stroke: "#4F31FF",
		strokeWidth: 1.67,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowRight;
